export default {
	sec_01: {
		title: {
			one: 'オンラインで送金する',
			two: '安全で面白',
			three: 'い方法',
		},
		desc: {
			one: '世界中のほぼすべての場所で家族や友だちに素',
			two: '早く送金できる簡単な方法です。',
		},
		btn: {
			one: '資産を送る',
			two: 'アプリダウンロード',
		},
	},
	sec_04: {
		title: 'すべての転送を最大限に活用',
		cards: {
			one: {
				title: '双方向のメッセージ',
				description: {
					one: '友達間の支払いが正しいかどうかを再確認するために',
					two: 'メッセージを交換してください。',
				},
			},
			two: {
				title: '無料オプション',
				description: {
					one: 'JP WORLD PAYポイントカードを使用して、',
					two: 'JP WORLD PAYの残高を確認した後、海外から',
					three: 'オンラインで送金することができます。',
				},
			},
			three: {
				title: '迅速なアクセス',
				description: {
					one: '暗号資産を送金する際、',
					two: '受信者は待たずにす',
					three: 'ぐ受け取ることができます',
				},
			},
		},
	},
	sec_03: {
		one: {
			title: {
				one: '年中無休モニタリング',
				two: '',
			},
			desc: {
				one: '暗号化技術により、JP WORLD PAYはあなたの送金が安全であること',
				two: 'を確認するために最善を尽くします。',
			},
		},
		two: {
			title: {
				one: '全世界へ送金',
			},
			desc: {
				one: 'JP WORLD PAYサービスを利用して、',
				two: '世界中のどこにでも送金してください。',
				three: '全世界中どこでも友達や家族にオンラインで送金',
			},
		},
	},
	sec_09: {
		title: {
			one: '0 JPYS',
			two: 'JPYS内取引手数料無料',
		},
		one: {
			desc: {
				one: '他行財布出金時に JP WORLD PAY残高からお金を送るとき 0%',
				two: '',
			},
		},
	},
};
